import { api } from './api.js';

export const importConfigAPI = {
  list: async (params = {}) => {
    const response = await api.get('/importConfig/list', { params });
    return response.data;
  },

  save: async (data) => {
    const response = await api.post('/importConfig/save', data);
    return response.data;
  },

  delete: async (Id) => {
    const response = await api.delete(`/importConfig/${Id}`);
    return response.data;
  },


  linkCompanyLayout: async (data) => {
    const response = await api.post('/companies/linkCompanyLayout', data);
    return response.data;
  },

  unlinkCompanyLayout: async (Id) => {
    const response = await api.delete(`/companies/unlinkCompanyLayout/${Id}`);
    return response.data;
  },

  listLayouts: async (configId) => {
    const response = await api.get('/layouts/list', { params: { configId } });
    return response.data;
  },

  listEnterprises: async (search = '', page = 0, limit = 20) => {
    const response = await api.get('/importConfig/listEnterprises', {
      params: { search, page, limit }
    });
    return response.data;
  },

  listCompanies: async (name, limit = 50) => {
    const response = await api.get('/companies/list', {
      params: { name, limit }
    });
    return response.data;
  },

  listCompaniesByConfig: async (configId, limit = 50) => {
    const response = await api.get('/companies/listByConfig', {
      params: { config_id: configId, limit }
    });
    return response.data;
  },

  layoutsByCompany: async (companyId) => {
    const response = await api.get('/companies/layoutsByCompany', {
      params: { companyId }
    });
    return response.data;
  },

  updateFantasyName: async (data) => {
    const response = await api.put('/companies/updateFantasyName', data);
    return response.data;
  },
  countWithoutLayout: async () => {
    const response = await api.get('/importConfig/countWithoutLayout');
    return response.data;
  },

  countEnterprises: async () => {
    const response = await api.get('/importConfig/countEnterprises');
    return response.data;
  },

  listUsers: async () => {
    const response = await api.get('/importConfig/users');
    return response.data;
  },
};


